import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getEmployees = ({
  churchId,
  isDenomination = false,
  denominationId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/employees`
  );
};

export const useEmployees = ({
  churchId,
  isDenomination = false,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["employees", isDenomination ? denominationId : churchId],
    queryFn: () => getEmployees({ churchId, isDenomination, denominationId })
  });
};
